import React from "react";
import { useLocation } from "../../context/LocationContext";
import { toast } from "react-toastify";
import { BsArrowRightCircle, BsDot } from "react-icons/bs";

export default function IconBoxStyle2({ title, subTitle, iconUrl, id }) {
    const { location } = useLocation();

    const handleRedirect = () => {
        // if (!location.type) {
        //     toast.warning("Please Select Location!");
        //     return;
        // }
        // window.location.href = `https://app.gkcklinica.com/public-profiles?locality_id=${
        //     !location.localityId ? "" : location.localityId
        // }&specialization_id=${id}&city_id=${
        //     !location.cityId ? "" : location.cityId
        // }&search_type=specialization`;

           window.location.href = `https://app.gkcklinica.com/public-profiles`
    };

    return (
        <div onClick={handleRedirect} className="cs_bento_card">
            <div className="cs_card_header">
                <div className="cs_icon_box">
                    <img src={iconUrl} alt={title} />
                </div>
                <div className="cs_availability">
                    <BsDot className="cs_dot_live" />
                    <span>Active Now</span>
                </div>
            </div>
            
            <div className="cs_card_body">
                <h3 className="cs_card_title">{title}</h3>
                <p className="cs_card_text">{subTitle}</p>
            </div>

            <div className="cs_card_footer">
                <span className="cs_footer_label">View Profiles</span>
                <BsArrowRightCircle className="cs_footer_arrow" />
            </div>
        </div>
    );
}